import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2072417a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "template-container" }
const _hoisted_2 = {
  style: {"font-size":"1.5rem","font-weight":"bold"},
  "data-cy": "category-name"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action-btn el-icon-edit-outline" }, null, -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "action-btn",
  style: {"margin-right":"2rem"}
}, "Edit", -1 /* HOISTED */))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action-btn el-icon-delete" }, null, -1 /* HOISTED */))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "action-btn" }, "Remove", -1 /* HOISTED */))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { style: {"font-size":"1.2rem","opacity":"50%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.categoryName), 1 /* TEXT */),
    _createElementVNode("div", {
      style: _normalizeStyle({
        fontSize: '1.2rem',
        visibility: $props.showActionsButtons ? 'visible' : 'hidden',
      }),
      class: "actions-section"
    }, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('editTemplate', $props.categoryId)), ["prevent"]))
      }, _hoisted_5),
      _createElementVNode("a", {
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('deleteTemplate', $props.categoryId)), ["prevent"]))
      }, _hoisted_8)
    ], 4 /* STYLE */),
    _createElementVNode("div", _hoisted_9, _toDisplayString($props.categoryPath), 1 /* TEXT */)
  ]))
}